// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".excel-export {\n  margin-left: 10px;\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  line-height: 30px;\n  text-align: center;\n}\n.excel-export i {\n  font-size: 10px;\n}\n@media (max-width: 750px) {\n.excel-export {\n    z-index: 2;\n    position: fixed;\n    right: 0.5rem;\n    bottom: 0.3rem;\n    width: 0.6rem;\n    height: 0.6rem;\n    line-height: 0.6rem;\n}\n.excel-export i {\n    font-size: 0.3rem;\n}\n}", ""]);
// Exports
module.exports = exports;
